// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"07bd9f12","453":"bda72b80"}[chunkId] + ".chunk.js";
};